export var KeywordFilterBarItemPlaceholderText = "Filter by keywords";
